import React from 'react'
import './index.css'

function Spinner(props) {
    return (
        <div className="spinner-wrapper" {...props}>
            <div className="spinner-border"></div>
        </div>
    )
}

export default Spinner
